import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { COLORS } from '@mafc/common';
import { ArrowLeft, RightArrow } from '@mafc/icon';
import { Breadcrumb, Types } from '@mafc/trolly';

import { isRTL } from 'config/localisation';
import PageMaxWidth from 'common/PageLayout/PageMaxWidth';

const breadcrumbGenerator = (details: Types.BreadcrumbItemHolderInterface) => {
  const { label, to, isItemInTheEnd, redirect = false } = details;
  if (redirect) {
    return <a href={to}>{label}</a>;
  }
  return !isItemInTheEnd ? <Link to={to}>{label}</Link> : <p>{label}</p>;
};

const breadcrumbConfig: any = (t: any) => {
  let Icon = RightArrow;
  let testid = 'RightArrow';

  if (isRTL()) {
    Icon = ArrowLeft;
    testid = 'ArrowLeft';
  }

  return {
    routes: [
      { label: t('home'), to: window.location.origin, redirect: true },
      { label: t('cart'), to: '/app/cart' },
    ],
    renderItem: breadcrumbGenerator,
    separator: <Icon testid={testid} size="XS" fill={COLORS.THUNDORA} />,
  };
};

const BreadCrumb = () => {
  const { t } = useTranslation();

  return (
    <PageMaxWidth mt={[0, 5]} mb={[0, 0, 4]} px={[3, null, null, null, 0]}>
      <Breadcrumb {...breadcrumbConfig(t)} />
    </PageMaxWidth>
  );
};

export default BreadCrumb;
